










































































































































































import { API } from "@/shared/api";
import { pedido } from "@/shared/dtos/pedido";
import pedidoModule from "@/store/modules/pedido-module";
import usuarioModule from "@/store/modules/usuario-module";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {
    MaterialCard: () => import("@/components/Cards/MaterialCard.vue"),
    DocumentsHandler: () => import("@/views/Documentos/DocumentsHandler.vue"),
    Xbtn: () => import("@/components/buttons/x-btn.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class FromularioImportacion extends Vue {
  public nombre: string = "";
  public pedido: pedido = new pedido();
  public estados = ["Pendiente", "Procesado", "Enviado", "Cancelado"];
  created() {
    usuarioModule.getmiusuario();
  }
  public get_url() {
    if (usuarioModule.mi_usuario.id_cliente > 0) {
      return {
        url:
          API.RepositorioInformes +
          "/documents/" +
          usuarioModule.mi_usuario.id_cliente,
        url_download:
          API.webApiBaseRepositoriArchivos +
          usuarioModule.mi_usuario.id_cliente,
      };
    } else {
      return {
        url: "",
        url_download: "",
      };
    }
  }
  @Watch("pedido.precio_con_iva")
  calcularPorcentajePagado() {
    this.pedido.porcentaje_valor_iva = this.calcularPorcentaje(
      this.pedido.valor_amazon,
      this.pedido.precio_con_iva
    );
  }
  @Watch("pedido.precio_sin_iva")
  calcularPorcentajeSINPagado() {
    this.pedido.porcentaje_valor_sin_iva = this.calcularPorcentaje(
      this.pedido.valor_amazon,
      this.pedido.precio_sin_iva
    );
  }
  @Watch("pedido.precio_con_iva")
  calcularPorcentajePagado2() {
    this.pedido.porcentaje_valor_iva = this.calcularPorcentaje(
      this.pedido.valor_amazon,
      this.pedido.precio_con_iva
    );
  }
  @Watch("pedido.valor_amazon")
  valor_amazon() {
    this.pedido.porcentaje_valor_iva = this.calcularPorcentaje(
      this.pedido.valor_amazon,
      this.pedido.precio_sin_iva
    );
  }
  @Watch("pedido.porcentaje_iva")
  calcularSinIVA() {
    this.pedido.precio_sin_iva = this.calcularPrecioSinIVA(
      this.pedido.precio_con_iva,
      this.pedido.porcentaje_iva
    );
  }

  calcular_todo() {
    this.calcularPorcentajePagado();
    this.calcularPorcentajeSINPagado();
    this.calcularPorcentajePagado2();
    this.valor_amazon();
    this.calcularSinIVA();
  }
  /**
   * Calcula el porcentaje pagado con base en el total y la cantidad pagada.
   * @param total - El valor total (base 100%).
   * @param pagado - La cantidad que se ha pagado.
   * @returns El porcentaje pagado, con dos decimales.
   */
  calcularPorcentaje(total: number, pagado: number): number {
    if (total <= 0) {
      return 0;
    }

    const porcentaje = (pagado / total) * 100;
    return parseFloat(porcentaje.toFixed(2)); // Redondea a dos decimales
  }

  /**
   * Calcula el precio sin IVA.
   * @param precioConIVA - El precio total con IVA incluido.
   * @param porcentajeIVA - El porcentaje del IVA (por ejemplo, 21 para un 21%).
   * @returns El precio sin IVA, con dos decimales.
   */

  calcularPrecioSinIVA(precioConIVA: number, porcentajeIVA: number): number {
    if (porcentajeIVA < 0) {
      return 0;
    }

    const precioSinIVA = precioConIVA / (1 + porcentajeIVA / 100);
    return parseFloat(precioSinIVA.toFixed(2)); // Redondea a dos decimales
  }

  public importarPedido() {
    pedidoModule.importarpedido(this.pedido);
  }

  public cancelar() {
    this.$router.back();
  }
}
